import { useCallback, useEffect, useRef, useState } from 'react';
import type { UIEvent } from 'react';

export const useHorizontalScrollShadows = () => {
    const scrollRef = useRef<HTMLDivElement>(null);
    const [showLeftShadow, setShowLeftShadow] = useState(false);
    const [showRightShadow, setShowRightShadow] = useState(false);

    const updateShadows = useCallback((element: HTMLDivElement) => {
        const { clientWidth, scrollLeft, scrollWidth } = element;
        const isScrollable = scrollWidth > clientWidth;

        setShowLeftShadow(isScrollable && scrollLeft > 0);
        setShowRightShadow(isScrollable && scrollLeft + clientWidth < scrollWidth - 1);
    }, []);

    const handleScroll = (event: UIEvent<HTMLDivElement>) => {
        updateShadows(event.currentTarget);
    };

    useEffect(() => {
        const scrollElement = scrollRef.current;
        if (!scrollElement) {
            return;
        }

        updateShadows(scrollElement);

        const resizeObserver = new ResizeObserver(() => updateShadows(scrollElement));
        resizeObserver.observe(scrollElement);

        return () => resizeObserver.disconnect();
    }, [updateShadows]);

    return { scrollRef, showLeftShadow, showRightShadow, handleScroll };
};
